var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"elevation":"2","type":"image, article"}})
}
var staticRenderFns = []

export { render, staticRenderFns }